let API_URL_CONFIG = '/api';
let AUTH_SECRET = 'FGj89P6O93869feYchKLBC3hRIo386fFeyTxV48b';
let AUTH_SERVICE = 'mediation-local';
let ADMIN_CELLADDITION = '';
let PRINT_URL = '';
let AUTH_URL = '';
let ESPACE_CLIENT_URL = '';

let env = window.location.hostname;
if (env.includes('localhost')) {
	AUTH_SERVICE = 'mediation-local';
	AUTH_SECRET = 'FGj89P6O93869feYchKLBC3hRIo386fFeyTxV48b';
	ADMIN_CELLADDITION = 'http://localhost:3003/admin';
	PRINT_URL = 'http://localhost:3010/';
	AUTH_URL = 'http://localhost:3000/';
	ESPACE_CLIENT_URL = 'http://localhost:3300/';
} else if (env.includes('laddit.io')) {
	AUTH_SERVICE = 'mediation';
	AUTH_SECRET = 'JeHDjdfh673bdjbrleYchKLBC3hRIo386fFeyTxV48b';
	ADMIN_CELLADDITION = ' https://commande-en-ligne.laddit.io/admin/#/general';
	PRINT_URL = 'https://ticket-print.laddit.io/';
	AUTH_URL = 'https://auth.laddit.io/';
	ESPACE_CLIENT_URL = 'https://espace-client.laddit.io/';
} else {
	AUTH_SECRET = 'PU6dAwjgkiPP6O938V48b69feYchKLBC3hRIo386fFeyTx';
	AUTH_SERVICE = 'mediation';
	ADMIN_CELLADDITION = 'https://commande-en-ligne.laddition.com/admin';
	PRINT_URL = 'https://ticket-qr.laddition.com/';
	AUTH_URL = 'https://auth.laddition.com/';
	ESPACE_CLIENT_URL = 'https://espace-client.laddition.com/';
}

export default {
	API_URL_CONFIG,
	AUTH_SECRET,
	AUTH_SERVICE,
	ADMIN_CELLADDITION,
	PRINT_URL,
	AUTH_URL,
	ESPACE_CLIENT_URL,
};
